import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMaximize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="m4.81 16.25 3.662-3.66a.75.75 0 1 0-1.061-1.061l-3.661 3.66v-3.13a.75.75 0 0 0-1.5 0V17a.747.747 0 0 0 .75.75h4.941a.75.75 0 0 0 0-1.5zM17.693 2.713A.75.75 0 0 0 17 2.25h-4.941a.75.75 0 0 0 0 1.5h3.13l-3.66 3.66a.75.75 0 0 0 1.06 1.062L16.25 4.81v3.13a.75.75 0 0 0 1.5 0V3a.8.8 0 0 0-.057-.287" />
  </svg>
);
export default SvgMaximize;
